'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var tailwindMerge = require('tailwind-merge');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var InputTypeSelector = require('./InputTypeSelector.js');

const LableInput = react.forwardRef((_a, ref)=>{
    var { isFixed, isFocused, isError, lable, placeholder, value, type } = _a, rest = _tslib.__rest(_a, [
        "isFixed",
        "isFocused",
        "isError",
        "lable",
        "placeholder",
        "value",
        "type"
    ]);
    const generateLableColor = ()=>{
        if (isError) return 'text-w-red-500';
        if (isFocused) return 'text-primary-500';
        return 'text-w-gray-400 group-hover:text-primary-500';
    };
    const generateLableAnimation = ()=>{
        if (isFixed) return 'typo-caption2';
        if (isFocused || !!value) return 'scale-[0.6875] -translate-y-0.5 origin-top-left transition-transform duration-300';
        return 'typo-body1 transition-transform duration-300 translate-y-2 origin-top-left';
    };
    return jsxRuntime.jsxs(Box, {
        className: "relative flex h-[42px] w-full flex-col gap-0.5 py-px",
        "data-testid": "design-system--lable-input",
        children: [
            jsxRuntime.jsx("div", {
                className: tailwindMerge.twMerge('absolute tracking-default', generateLableColor(), generateLableAnimation()),
                "data-testid": "design-system--lable-text",
                children: lable
            }),
            jsxRuntime.jsx(InputTypeSelector, Object.assign({
                type: type
            }, rest, {
                ref: ref,
                className: "pt-[14px]"
            }))
        ]
    });
});
LableInput.displayName = 'LableInput';

module.exports = LableInput;
